import React from "react";
import { Route, Routes } from "react-router-dom";
import { adminProtectedRoutes, adminPublicRoutes, authProtectedRoutes, publicRoutes } from "./all-routes";
import Layout from "layout";
import NonAuthLayout from "layout/non-layout";
import AuthProtected from "./auth-protected";

const RouteIndex = () => {
  return (
    <React.Fragment>
      <Routes>
        {adminPublicRoutes.map((route: any, idx: number) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <NonAuthLayout>
                <route.component />
              </NonAuthLayout>
            }
          />
        ))}

        {adminProtectedRoutes.map((route: any, idx: number) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <AuthProtected>
                <Layout type={2}>
                  <route.component />
                </Layout>
              </AuthProtected>
            }
          />
        ))}

        {authProtectedRoutes.map((route: any, idx: number) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <AuthProtected>
                <Layout type={1}>
                  <route.component />
                </Layout>
              </AuthProtected>
            }
          />
        ))}
        {publicRoutes.map((route: any, idx: number) => (
          <Route
            path={route.path}
            key={idx}
            element={
              <NonAuthLayout>
                <route.component />
              </NonAuthLayout>
            }
          />
        ))}
      </Routes>
    </React.Fragment>
  );
};

export default RouteIndex;
